import { Link, NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { Moon, Sun, Menu, X } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const navItems = [
  { to: "/", label: "Interview", testid: "header-nav-interview" },
  { to: "/work", label: "More work", testid: "header-nav-work" },
  { to: "/resume", label: "Résumé", testid: "header-nav-resume" },
];

const isWorkActive = (pathname) => pathname.startsWith("/work");

export const Header = () => {
  const { theme, toggle } = useTheme();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  const linkClass = (item) => {
    const active =
      item.to === "/work" ? isWorkActive(pathname) : pathname === item.to;
    return `text-sm font-medium transition-colors ${
      active ? "text-[var(--accent)]" : "text-[var(--text-2)] hover:text-[var(--text)]"
    }`;
  };

  return (
    <header
      className="no-print sticky top-0 z-50 border-b border-[var(--border)]"
      style={{ background: "color-mix(in srgb, var(--bg) 78%, transparent)", backdropFilter: "blur(16px)" }}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3.5 sm:px-8">
        <Link to="/" data-testid="header-logo" className="group flex flex-col leading-tight">
          <span className="font-head text-base font-bold tracking-tight">Matt Kolar</span>
          <span className="font-mono text-[0.62rem] uppercase tracking-[0.18em] text-[var(--text-muted)]">
            Interview companion
          </span>
        </Link>

        <nav className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.to === "/"} data-testid={item.testid} className={() => linkClass(item)}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <span className="ic-pill hidden sm:inline-flex" data-testid="built-with-emergent-badge">
            Built with Emergent
          </span>
          <button
            type="button"
            onClick={toggle}
            aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
            data-testid="theme-toggle-button"
            className="ic-btn !p-2.5 !rounded-full"
          >
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle navigation menu"
            aria-expanded={open}
            data-testid="mobile-menu-button"
            className="ic-btn !p-2.5 !rounded-full md:hidden"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-[var(--border)] px-5 py-3 md:hidden" data-testid="mobile-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`${item.testid}-mobile`}
              onClick={() => setOpen(false)}
              className={() => `block py-2.5 ${linkClass(item)}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
